import { render } from "./headline.vue?vue&type=template&id=947006be&lang=pug"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/headline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "947006be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('947006be', __exports__)) {
    api.reload('947006be', __exports__)
  }
  
  module.hot.accept("./headline.vue?vue&type=template&id=947006be&lang=pug", () => {
    api.rerender('947006be', render)
  })

}


export default __exports__